// extracted by mini-css-extract-plugin
export default {"bankid-mobile":"styles_bankid-mobile__74IO+","status-message":"styles_status-message__eLLmK","padding":"styles_padding__ZIVNb"};